import neApi from './api';
import evaApi from './apiEvaluation';

export default {
  // 测评A卷-老
  // getEvaluationUserInfo: (params?: any) =>
  //   apiGet('/gateway/api/evaluation/getEvaluationUserInfo', params),
  // startEvaluation: () => apiGet('/gateway/api/evaluation/getEvaluateUrl')
  getEvaluationUserInfo: (params?: any) => {
    //获取当前用户测评信息
    return neApi.get('/wx/app/evaluation/getEvaluationUserInfo', params);
  },
  checkEvaluationStatus: (params?: any) => {
    return neApi.post(`/wx/app/evaluation/startEvaluation`, params);
  },
  getEvaluateUrl: () => {
    //立即测评按钮-返回测评链接
    return neApi.get('/wx/app/evaluation/url', {});
  },
  openApesk: (params?: any) => {
    return neApi.get('/wx/app/apesk/url', params);
  },
  apeskInfo: (params?: any) => {
    return neApi.get('/apesk/info', params);
  },

  // 测评B-新
  findUserEvaluation: (params?: any) => {
    return evaApi.get('/wx/app/evaluation/findUserEvaluation', params);
  },
  startEntryEvaluation: (params?: any) => {
    return evaApi.get('/wx/app/evaluation/intoEvaluation', params);
  },
  smsCode: (params?: any) => {
    return neApi.post('/wx/app/login/sms/code', params);
  },
  login: (params?: any) => {
    return neApi.post('/wx/app/login/sms', params);
  },
  getUserEvaluationList: () => {
    return neApi.get('/wx/app/evaluation/list');
  },
  getArticle: (params?: any) => {
    return neApi.get('/wx/app/article/content', params);
  }
};
